import GooglePlayLink from "../GooglePlayLink";
import classes from "./index.module.scss";
import { ReactComponent as AppStore } from "../../WeedAR/images/appstore.svg";

export default function Buttons({ className }) {
  return (
    <div className={`${classes.buttons} ${className ? className : ""}`}>
      <GooglePlayLink />
      <a
        className={`${classes.link}`}
        href="https://apps.apple.com/ua/app/shapely-workouts-fitness/id6444711129?l=uk"
        target="_blank"
        rel="noopener noreferrer"
      >
        <AppStore />
      </a>
    </div>
  );
}
